<script>
	import { pages } from '../share/stores';
	import { eagerLoadingLeftImages } from '../share/utils';

	import Accordion from '../components/content/Accordion.svelte';
	import Counters from '../components/content/Counters.svelte';
	import CustomButton from '../components/content/CustomButton.svelte';
	import GetInTouch from '../components/content/GetInTouch.svelte';
	import ImageGallery from '../components/content/ImageGallery.svelte';
	import InputForm from '../components/content/InputForm.svelte';
	import LinkWall from '../components/content/LinkWall.svelte';
	import LogoWall from '../components/content/LogoWall.svelte';
	import PDFWalker from '../components/content/PDFWalker.svelte';
	import Tabs from '../components/content/Tabs.svelte';
	import TextBox from '../components/content/TextBox.svelte';

	import DefaultHTML from '../components/content/DefaultHTML.svelte';
	import SmartLink from '../helpers/SmartLink.svelte';

	export let ready = false;
	export let isRightSide;
	export let rightSideRendered;

	//special-Components
	// 01.Home
	import Home_IndividuelleSoftwareentwicklung from '../components/content/special-components/01.Home/03.individuelle-softwareentwicklung.svelte';
	import Home_AppsUndAds from '../components/content/special-components/01.Home/04.apps-und-ads.svelte';
	import Home_FrontendEntwicklung from '../components/content/special-components/01.Home/05.frontend-entwicklung.svelte';

	// 02.Agentur
	import Agentur_OfficeView from
				'../components/content/special-components/02.Agentur/02.office-view.svelte';
	import Agentur_Team from
				'../components/content/special-components/02.Agentur/04.team.svelte';

	// 02.Agentur/07.Jobs/03.office
	import Agentur_Jobs_Office from
				'../components/content/special-components/02.Agentur/07.Jobs/03.office.svelte';
	import Agentur_Jobs_Details from
				'../components/content/special-components/02.Agentur/07.Jobs/05.details.svelte';

	// 10.Appetit_Digitalisieren
	import Appetit_Digitalisieren_Cookies from
				'../components/content/special-components/10.Appetit_Digitalisieren/01.cookies.svelte';
	import Appetit_Digitalisieren_AppetitDigitalisieren from
				'../components/content/special-components/10.Appetit_Digitalisieren/03.appetit_digitalisieren.svelte';
	import Appetit_Digitalisieren_Aktionswebsites from
				'../components/content/special-components/10.Appetit_Digitalisieren/05.aktionswebsites.svelte';
	import Appetit_Digitalisieren_AdAdHurra from
				'../components/content/special-components/10.Appetit_Digitalisieren/06.ad_ad_hurra.svelte';
	import Appetit_Digitalisieren_Loesungen from
				'../components/content/special-components/10.Appetit_Digitalisieren/08.loesungen.svelte';
	import Appetit_Digitalisieren_ContentKing from
				'../components/content/special-components/10.Appetit_Digitalisieren/09.content_king.svelte';

	// 11.Ueberflieger
	import Ueberflieger_Cloud from
				'../components/content/special-components/11.Ueberflieger/02.cloud.svelte';
	import Ueberflieger_Reiseziele from
				'../components/content/special-components/11.Ueberflieger/04.reiseziele.svelte';
	import Ueberflieger_Beratung from
				'../components/content/special-components/11.Ueberflieger/06.beratung.svelte';

	// 12.Menschen_Bewegen
	import Menschen_Bewegen_Launch from
				'../components/content/special-components/12.Menschen_Bewegen/02.launch.svelte';
	import Menschen_Bewegen_Programmierung from
				'../components/content/special-components/12.Menschen_Bewegen/04.programmierung.svelte';
	import Menschen_Bewegen_Beratung from
				'../components/content/special-components/12.Menschen_Bewegen/06.beratung.svelte';

	// 13.Stream_On
	import Stream_On_Opener from
				'../components/content/special-components/13.Stream_On/02.opener.svelte';

	// 14.Weltweit_Regional
	import Weltweit_Regional_Kulturhauptstadt from
				'../components/content/special-components/14.Weltweit_Regional/02.kulturhauptstadt.svelte';

	// 15.Kein_Mittelmass
	import Kein_Mittelmass_Decor from
				'../components/content/special-components/15.Kein_Mittelmass/01.decor.svelte';
	import Kein_Mittelmass_Hopefner from
				'../components/content/special-components/15.Kein_Mittelmass/03.hoepfner.svelte';
	import Kein_Mittelmass_Programming from
				'../components/content/special-components/15.Kein_Mittelmass/06.programming.svelte';
	import Kein_Mittelmass_Miscellaneous from
				'../components/content/special-components/15.Kein_Mittelmass/08.miscellaneous.svelte';

	// 16.Individuelle_Klasse
	import Individuelle_Klasse_Surgery from
				'../components/content/special-components/16.Individuelle_Klasse/02.surgery.svelte';
	import Individuelle_Klasse_TOM from
				'../components/content/special-components/16.Individuelle_Klasse/04.tom.svelte';
	import Individuelle_Klasse_CarUI from
				'../components/content/special-components/16.Individuelle_Klasse/06.car_ui.svelte';
	import Individuelle_Klasse_SocialChain from
				'../components/content/special-components/16.Individuelle_Klasse/07.social_chain.svelte';

	// 17.Health_And_Care
	import Health_And_Care_Cleverfit from
				'../components/content/special-components/17.Health_And_Care/02.cleverfit.svelte';
	import Health_And_Care_Insurance from
				'../components/content/special-components/17.Health_And_Care/04.insurance.svelte';
	import Health_And_Care_Scan from
				'../components/content/special-components/17.Health_And_Care/05.scan.svelte';
	import Health_And_Care_Guide from
				'../components/content/special-components/17.Health_And_Care/07.guide.svelte';

	// 18.BurgEins_Stromert
	import BurgEins_Stromert_Advent from
				'../components/content/special-components/18.BurgEins_Stromert/02.advent.svelte';
	import BurgEins_Stromert_Seasons from
				'../components/content/special-components/18.BurgEins_Stromert/04.seasons.svelte';

	// 19.Opel_Case_Study
	import Opel_Case_Study_Marktlaunch from
				'../components/content/special-components/19.Opel_Case_Study/02.marktlaunch.svelte';
	import Opel_Case_Study_Idee from
				'../components/content/special-components/19.Opel_Case_Study/04.idee.svelte';

	import Opel_Case_Study_Kreativitaet from
				'../components/content/special-components/19.Opel_Case_Study/06.kreativitaet.svelte';

	// 20.AES_HUB_Case_Study
	import AES_HUB_Decor from
            '../components/content/special-components/20.AES_HUB/01.decor.svelte';
	import AES_HUB_Intro from
            '../components/content/special-components/20.AES_HUB/02.intro.svelte';
	import AES_HUB_Award_Winning from
            '../components/content/special-components/20.AES_HUB/03.award_winning.svelte';

	import PageContentParser from './PageContentParser.svelte';
	import Slider from '../components/content/Slider.svelte';

	export let meta;
	export let html;
	export let attributes = {};
	export let tag = 'div';

	export let id = false;

	let tempDivChildren = [];
	let components = [];

	components['div.accordion'] = Accordion;
	components['div.counters'] = Counters;
	components['div.custombutton'] = CustomButton;
	components['div.get-in-touch'] = GetInTouch;
	components['div.imagegallery'] = ImageGallery;
	components['div.inputform'] = InputForm;
	components['div.linkwall'] = LinkWall;
	components['div.logowall'] = LogoWall;
	components['div.pdfwalker'] = PDFWalker;
	components['div.tabs'] = Tabs;
	components['div.textbox'] = TextBox;
	components['div.slider'] = Slider;

	components['smartlink'] = SmartLink;

	// 01.Home
	const homeDivClass = 'div.01.Home/';
	components[`${homeDivClass}03.individuelle-softwareentwicklung`] = Home_IndividuelleSoftwareentwicklung;
	components[`${homeDivClass}04.apps-und-ads`] = Home_AppsUndAds;
	components[`${homeDivClass}05.frontend-entwicklung`] = Home_FrontendEntwicklung;

	// 02.Agentur
	const agenturDivClass = 'div.02.Agentur/';
	components[`${agenturDivClass}02.office-view`] = Agentur_OfficeView;
	components[`${agenturDivClass}04.team`] = Agentur_Team;

	// 02.Agentur/07.Jobs/03.office
	const agenturJobsDivClass = 'div.02.Agentur/07.Jobs/';
	components[`${agenturJobsDivClass}03.office`] = Agentur_Jobs_Office;
	components[`${agenturJobsDivClass}05.details`] = Agentur_Jobs_Details;

	// 10.Appetit_Digitalisieren
	const appetitDivClass = 'div.10.Appetit_Digitalisieren/';
	components[`${appetitDivClass}01.cookies`] = Appetit_Digitalisieren_Cookies;
	components[`${appetitDivClass}03.appetit_digitalisieren`] = Appetit_Digitalisieren_AppetitDigitalisieren;
	components[`${appetitDivClass}05.aktionswebsites`] = Appetit_Digitalisieren_Aktionswebsites;
	components[`${appetitDivClass}06.ad_ad_hurra`] = Appetit_Digitalisieren_AdAdHurra;
	components[`${appetitDivClass}08.loesungen`] = Appetit_Digitalisieren_Loesungen;
	components[`${appetitDivClass}09.content_king`] = Appetit_Digitalisieren_ContentKing;

	// 11.Ueberflieger
	const ueberfliegerDivClass = 'div.11.Ueberflieger/';
	components[`${ueberfliegerDivClass}02.cloud`] = Ueberflieger_Cloud;
	components[`${ueberfliegerDivClass}04.reiseziele`] = Ueberflieger_Reiseziele;
	components[`${ueberfliegerDivClass}06.beratung`] = Ueberflieger_Beratung;

	// 12.Menschen_Bewegen
	const menschenBewegenDivClass = 'div.12.Menschen_Bewegen/';
	components[`${menschenBewegenDivClass}02.launch`] = Menschen_Bewegen_Launch;
	components[`${menschenBewegenDivClass}04.programmierung`] = Menschen_Bewegen_Programmierung;
	components[`${menschenBewegenDivClass}06.beratung`] = Menschen_Bewegen_Beratung;

	// 13.Stream_On
	const streamOnDivClass = 'div.13.Stream_On/';
	components[`${streamOnDivClass}02.opener`] = Stream_On_Opener;

	// 14.Weltweit_Regional
	const regionalDivClass = 'div.14.Weltweit_Regional/';
	components[`${regionalDivClass}02.kulturhauptstadt`] = Weltweit_Regional_Kulturhauptstadt;

	// 15.Kein_Mittelmass
	const mittelmassDivClass = 'div.15.Kein_Mittelmass/';
	components[`${mittelmassDivClass}01.decor`] = Kein_Mittelmass_Decor;
	components[`${mittelmassDivClass}03.hoepfner`] = Kein_Mittelmass_Hopefner;
	components[`${mittelmassDivClass}06.programming`] = Kein_Mittelmass_Programming;
	components[`${mittelmassDivClass}08.miscellaneous`] = Kein_Mittelmass_Miscellaneous;

	// 16.Individuelle_Klasse
	const idividuelleKlasseDivClass = 'div.16.Individuelle_Klasse/';
	components[`${idividuelleKlasseDivClass}02.surgery`] = Individuelle_Klasse_Surgery;
	components[`${idividuelleKlasseDivClass}04.tom`] = Individuelle_Klasse_TOM;
	components[`${idividuelleKlasseDivClass}06.car_ui`] = Individuelle_Klasse_CarUI;
	components[`${idividuelleKlasseDivClass}07.social_chain`] = Individuelle_Klasse_SocialChain;

	// 17.Health_And_Care
	const healthDivClass = 'div.17.Health_And_Care/';
	components[`${healthDivClass}02.cleverfit`] = Health_And_Care_Cleverfit;
	components[`${healthDivClass}04.insurance`] = Health_And_Care_Insurance;
	components[`${healthDivClass}05.scan`] = Health_And_Care_Scan;
	components[`${healthDivClass}07.guide`] = Health_And_Care_Guide;

	// 18.BurgEins_Stromert
	const stromerDivClass = 'div.18.BurgEins_Stromert/';
	components[`${stromerDivClass}02.advent`] = BurgEins_Stromert_Advent;
	components[`${stromerDivClass}04.seasons`] = BurgEins_Stromert_Seasons;

	// 19.Opel_Case_Study
	const opelDivClass = 'div.19.Opel_Case_Study/';
	components[`${opelDivClass}02.marktlaunch`] = Opel_Case_Study_Marktlaunch;
	components[`${opelDivClass}04.idee`] = Opel_Case_Study_Idee;
	components[`${opelDivClass}06.kreativitaet`] = Opel_Case_Study_Kreativitaet;

	// 20.AES_HUB
	const aesDivClass = 'div.20.AES_HUB/';
	components[`${aesDivClass}01.decor`] = AES_HUB_Decor;
	components[`${aesDivClass}02.intro`] = AES_HUB_Intro;
	components[`${aesDivClass}03.award_winning`] = AES_HUB_Award_Winning;

	let tempDiv;

	function parseMdCodeBlock(domElement, meta) {
		if (domElement.tagName.toLowerCase() !== 'code' || domElement.classList.length > 0) {
			domElement.meta = meta;
			return domElement;
		}
		const tempDiv = document.createElement('div');
		tempDiv.innerHTML = domElement.innerText;
		tempDiv.meta = meta;
		// tempDiv.attributes = domElement.attributes;
		return tempDiv;
	}

	function generateComponentName(element) {
		let componentName = element.tagName.toLowerCase();
		element.classList.forEach(_class => {
			if (components[componentName + '.' + _class]) {
				componentName += '.' + _class;
			}
		});
		return componentName;
	}

	let firstChildren = [];
	let remainingChildren = [];

	function render() {
		if(!isRightSide && !rightSideRendered) {
			requestAnimationFrame(render);
			return;
		}
		tempDiv = document.createElement(tag);
		tempDiv.innerHTML = html;
		tempDiv.meta = tempDiv.querySelectorAll('.meta');
		//codeBlocks from Markdown need special treatment:
		tempDivChildren = Array.from(tempDiv.childNodes).map(_child => {
			// make "#text"-Elements parsable using a "p"-Tag as they miss alot of DOM-properties:
			if (!_child.tagName) {
				const tempP = document.createElement('span');
				tempP.innerText = _child.textContent.trim();
				tempP.empty = tempP.innerText === '';
				return tempP;
			}
			return parseMdCodeBlock(_child, tempDiv.querySelectorAll('.meta'));
		});

		firstChildren = tempDivChildren.slice(0, 6);
		remainingChildren = tempDivChildren.slice(6);
		if(isRightSide) {
			if($pages[$pages.length - 1]?.scrollTop > 0) {
				$pages[$pages.length - 1].autoScroll = true;
				let scrollAttempts = 20;
				setTimeout(() => {
					const scrollTop = parseInt($pages[$pages.length - 1]?.scrollTop);
					const rightScrollBox = document.querySelector('.content .container > .right');
					function scrollRightBox() {
						rightScrollBox.scroll({top: scrollTop || 0});
						// done setting position:
						if(scrollTop === rightScrollBox.scrollTop) {
							$pages[$pages.length - 1].autoScroll = false;
							return;
						}
						// retry - a fallback when images take way to long to load
						// -> shouldn't happen very often, as most images of a previous page are cached by now:
						if(scrollTop !== rightScrollBox.scrollTop && scrollAttempts > 0) {
							scrollAttempts--;
							requestAnimationFrame(scrollRightBox);
						}
					}
					Array.from(rightScrollBox.querySelectorAll('img')).forEach(img => {
						img.loading = 'eager';
						if(img.complete) {
							scrollRightBox();
							return;
						}
						img.onload = () => scrollRightBox();
					});
					// if correct position not reached till now, wait a bit more:
					if(scrollTop !== rightScrollBox.scrollTop) {
						setTimeout(() => {
							scrollAttempts = 100;
							$pages[$pages.length - 1].autoScroll = false;
							scrollRightBox();
						}, 200);
					}
				}, 200);
			}
			rightSideRendered = true;
		} else {
			if($pages[$pages.length - 2]?.scrollTop > 0) {
				const leftScrollBox = document.querySelector('.content .container > .left');
				// uses a given list of elements and a search-function to find them in tracked elements:
				function setAspectRatios(elements, searchRefs) {
					Array.from(elements).forEach(element => {
						function setAspectRatio() {
							const rightRef = searchRefs($pages[$pages.length - 2].refs, element);
							if(rightRef) {
								element.parentElement.style.aspectRatio = rightRef.parentAspectRatio;
								element.parentElement.style.height = rightRef.parentHeight;
								element.style.aspectRatio = rightRef.aspectRatio;
								leftScrollBox.querySelector('.outer').style.width = rightRef.containerWidth + 'px';
							}
						}
						setAspectRatio();
					});
				}
				setTimeout(() => {
					eagerLoadingLeftImages();
					setAspectRatios(leftScrollBox.querySelectorAll('img'), (refs, element) =>
						refs.find(ref =>
							ref.ref === element?.src ||
										element.id ||
										Array.from(element.childNodes).map(node => node.className).reduce((sum, a) => sum += a != ''? a : '', '')
					));
					if(leftScrollBox.querySelector('.inner > ul > li')) {
						// searchRefs = classNames as concatenated string
						setAspectRatios(leftScrollBox.querySelector('.inner > ul > li').children, (refs, element) =>
							refs.find(ref => ref.ref ===
								Array.from(element.childNodes).map(node => node.className).reduce((sum, a) => sum += a, ''))
						);
					}
					let scrollTop = $pages[$pages.length - 2]?.scrollTop;
					leftScrollBox.scroll({top: scrollTop || 0});
				}, 200);
			}
		}
	}

	render();
</script>


{#each firstChildren as child, pageContentIndex}
	{#if !child.empty && child.tagName}
		<svelte:component
				{isRightSide}
				this={components[generateComponentName(child)] || DefaultHTML}
				html={child.outerHTML}
				meta={child.meta}
				tag={child?.tagName.toLowerCase() || ''}
				id={child?.id}
				attributes={child.attributes}
				{pageContentIndex}
		>
			{#if child.children.length > 0}
				<PageContentParser
						{isRightSide}
						bind:rightSideRendered
						html={child.innerHTML}
						meta={child.meta}
						tag={child?.tagName || ''}
						id={child?.id}
						attributes={child.attributes}
						{pageContentIndex}
				/>
			{:else}
				{@html child.outerHTML.fixImageAndApiLinkPath()}
			{/if}
		</svelte:component>
	{/if}
{/each}

{#each remainingChildren as child, pageContentIndex}
	{#if !child.empty && child.tagName}
		<svelte:component
				{isRightSide}
				this={components[generateComponentName(child)] || DefaultHTML}
				html={child.outerHTML}
				meta={child.meta}
				tag={child?.tagName.toLowerCase() || ''}
				id={child?.id}
				attributes={child.attributes}
				pageContentIndex={firstChildren.length + pageContentIndex}
		>
			{#if child.children.length > 0}
				<PageContentParser
						{isRightSide}
						bind:rightSideRendered
						html={child.innerHTML}
						meta={child.meta}
						tag={child?.tagName || ''}
						id={child?.id}
						attributes={child.attributes}
						pageContentIndex={firstChildren.length + pageContentIndex}
				/>
			{:else}
				{@html child.outerHTML.fixImageAndApiLinkPath()}
			{/if}
		</svelte:component>
	{/if}
{/each}
